module.exports = __webpack_public_path__ + "fa0aa6da53a8a0f78a2dfc3356e39c37.jpg";